<template>
  <div class="container-fluid" style="height:100vh;width:100vw;">
    <div class="spinner-container" v-if="loading == 1">
      <div id="loader"></div>
    </div>
    <div class="row" style="height:inherit;width:inherit;">
      <div class="col-lg-2 col-md-2" style="paddingLeft:0px;">
        <Sidebar></Sidebar>
      </div>
      <div class="col-lg-10 col-md-10 col-12 mt-2 pl-5 cust">
        <div class="row h3 repo">Generate Report</div>
        <!-- <Notification></Notification> -->
        <div class="row border report">
          <div class="col-lg-3"></div>
          <div class="col-lg-6 my-4">
            <select class="custom-select" v-model="companyId">
              <option selected disabled value="">Select Customer</option>
              <option
                v-for="customer in customers"
                v-bind:key="customer._id"
                :value="customer._id"
              >{{customer.name}}</option>,
            </select>

            <select class="custom-select mt-5" v-model="pollutant">
              <option selected value="ALL">ALL Pollutant</option>
              <option value="TVOC">TVOC</option>
              <option value="HCHO">HCHO</option>
              <option value="CO2">CO2</option>
              <option value="PM1">PM1</option>
              <option value="PM25">PM2.5</option>
              <option value="PM10">PM10</option>
            </select>

            <select class="custom-select mt-5"  v-model="statistics">
              <option selected disabled value="">Statistics</option>
              <option value="Average">Average</option>
              <option value="Maximum">Maximum</option>
              <option value="Minimum">Minimum</option>
            </select>

            <select class="custom-select mt-5" v-model="period">
              <option selected disabled value="">Period</option>
              <option value="1">1 minutes</option>
              <option value="5">5 minutes</option>
              <option value="10">10 minutes</option>
              <option value="15">15 minutes</option>
              <option value="30">30 minutes</option>
              <option value="60">Hourly</option>
              <!-- <option value="1440">Daily</option>
              <option value="10080">Weekly</option> -->
            </select>

            <div class="mt-5 text-center">
                <date-picker :lang="lang" placeholder="Time range" v-model="range" range></date-picker>
            </div>
            <div class="text-center mt-3">
              <button @click="getReport()" class="btn btn-danger">Get Report</button>
            </div>
          </div>
          <div class="col-lg-3"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import _ from 'underscore';
import Toasted from 'vue-toasted'
import Vue from 'vue';
import axios from 'axios';
import FileSaver from 'file-saver';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { apiCall } from '@/utils/api';
import Sidebar from './Sidebar';
// import Notification from './Notification';
import moment from 'moment';
import _ from 'underscore';

Vue.use(Toasted)
export default {
  mounted() {
    this.getAllCustomers();
  },
  data() {
    return {
      loading: 0,
      statistics: '',
      period: '',
      pollutant: 'ALL',
      companyId: '',
      customers: [],
      activeClass: 'active',
      range: '',
       lang: {
          formatLocale: {
            firstDayOfWeek: 1,
          },
          monthBeforeYear: false,
        },
    };
  },
  components: {
    Sidebar,
    Notification,
    DatePicker,
  },
  methods: {
    getReport() {
      
      this.loading = 1;
      if (this.statistics === '' || this.period === '' || this.companyId === '' || this.range === '') {
        this.$toasted.show('please fill all input', { duration: 1000 })
        return
      }
      let body = {
        statisticType: this.statistics,
        period: parseInt(this.period),
        pollutant: this.pollutant,
        companyId: this.companyId,
        from: moment(this.range[0]).startOf('day').unix(),
        to: moment(this.range[1]).endOf('day').unix(),
      }
      const custName = this.getCustomerName(this.companyId);
      // let url = 'readings/reports'
      const token = localStorage.getItem('user-token') || '';
      if (token) {axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;}
      apiCall({ url: 'reading/reports', method: 'post', data: body })
      .then((response) => {
        // console.log('response',JSON.stringify(response));
        this.loading = 0;
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 
        `${custName}_${moment().format("DD_mm_YYYY_HH:MM:SS")}.csv`); //or any other extension
        document.body.appendChild(link);
        link.click();
      }).catch((err) => {
        this.loading = 0;
        // console.log('error', err)
      })
    },
    getCustomerName(companyId) {
      const custSelected = this.customers.filter((cust) => {
        return cust._id == companyId ;
      })
      const custName = _.pluck(custSelected,'name')
      return custName[0];
    },
    getAllCustomers() {
      apiCall({ url: 'company', method: 'get' })
        .then((resp) => {
          this.customers = resp.data;
          // console.log('response', resp);
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>
<style>
.spinner-container {
  position: absolute;
  width: 100%;
  height: 100%;
  background: black;
  opacity: 0.6;
  z-index: 1;
  margin: -15px;
}
.container-fluid {
  margin: 0px;
  padding: 0px;
}
.card {
  background: #fff;
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.62rem;
  width: 100%;
  height: 8rem;
  font-family: Ubuntu;
  font-size: 10px;
  color: rgba(59, 59, 59, 0.8);
}
.card-title {
  text-transform: capitalize;
  font-family: Ubuntu;
  font-size: 1.4rem;
  color: rgba(59, 59, 59, 0.8);
}
.card-text {
  word-wrap: break-word;
  font-size: 0.8rem !important;
}
.card-body {
  padding: 0px;
}

.cust {
  font-family: Ubuntu;
  font-weight: 200;
  color: rgba(59, 59, 59, 0.8);
}
.status-cont {
  padding: 0px !important;
}
.total {
  padding: 0px !important;
  font-size: 0.8rem;
}
.report {
  box-shadow: 0 0 0.62rem 0 rgba(0, 0, 0, 0.2);
  border-radius: 0.62rem;
}
option {
  font-size: 14px;
}
.mx-datepicker, .mx-datepicker-range{
width:27rem;
height: calc(1.5em + .75rem + 2px);
}
.repo {
  padding-left: 0.75rem !important;
}

</style>
